function t(t){return"x"===t?"y":"x"}export{t as default};
//# sourceMappingURL=getAltAxis.js.map
